import {Children} from 'rlink-react';

export function elementOf (element) {
  return (props, propName, componentName) => {
    try {
      return (Children.map(props.children,
        child => (
          (child && child.type !== element)
          ? new Error(`${componentName} children should always be of type '${element.name}'. We found a ${child.type}.`)
          : null
        )
      ) || []).find(result => result instanceof Error) || null;
    } catch (e) {
      console.warn('ERROR in PropType check: elementOf', e);
      return null;
    }
  };
}




// WEBPACK FOOTER //
// ./lib/rlink-utils/RlinkPropTypes.js